import Head from 'next/head';
import { HomeHeader } from '@/components/main-page/HomeHeader';
import { Footer } from '@/components/main-page/Footer';
import { Hero } from '@/components/main-page/Herov2';
import { GallerySection } from './GallerySection';
import { SocialJob } from './SocialJob';
import { Jobs } from './Jobs';
import { CTA } from './CTAv2';
import { PromotionalVideo } from './PromotionalVideo';
import { Testimonials } from './TestimonialsJob';
import CompanyLogos from './CompanyLogos';
import { Container } from '../common/Container';
import TalentBank from './TalentBank';

export function Home({
  jobs,
  company,
  photoPath,
  style,
  child_companies_logo,
  type,
  company_page_url,
}) {
  const components = [
    {
      component: HomeHeader,
      props: {
        company_id: company.company_id,
        type,
        logo: company?.f_logo,
        photoPath,
        website: company?.social_medias?.website,
        style,
        company_page_url,
      },
      show: true,
    },
    {
      component: Hero,
      props: {
        company_name: company?.name,
        text: company?.hero_text,
        banner: company?.f_banner,
      },
      show: true,
    },
    {
      component: Jobs,
      props: { jobs },
      show: true,
    },
    {
      component: TalentBank,
      props: {},
      show: true,
    },
    {
      component: CTA,
      props: {
        type,
        about: company?.public_about,
        about_image: company?.f_about,
        mission: company?.mission,
        vision: company?.vision,
        values: company?.values,
        style,
      },
      show: !!company?.public_about,
    },
    {
      component: GallerySection,
      props: {
        gallery: company?.gallery,
        name: company?.name || 'Avanci AI',
      },
      show: (type === 'business' || type === 'partner') && company?.gallery?.length >= 4,
    },
    {
      component: CompanyLogos,
      props: {
        child_companies_logo,
        company_name: company?.name,
      },
      show:
        company?.company_id === '57e635df-94d1-4f2f-9237-5eb9ebbbdae6' &&
        child_companies_logo &&
        child_companies_logo?.length >= 5,
    },
    {
      component: Testimonials,
      props: { testimonies: company.testimonies },
      show: (company?.testimonies?.length || 0) >= 2,
    },
    {
      component: Container,
      props: {
        children: (
          <div
            className={`flex flex-col ${
              company?.f_video?.id == '00000000-0000-0000-0000-000000000000' &&
              'justify-center items-center'
            } gap-8 lg:flex-row lg:gap-[149px] py-10`}
          >
            {company?.social_medias && Object.keys(company?.social_medias).length > 0 && (
              <SocialJob social_medias={company?.social_medias} />
            )}
            {company?.f_video?.id != '00000000-0000-0000-0000-000000000000' && (
              <PromotionalVideo video={company?.f_video} />
            )}
          </div>
        ),
      },
      show: true,
    },
    {
      component: Footer,
      props: {},
      show: true,
    },
  ];

  return (
    <div style={style}>
      <Head>
        <title>{company?.name || 'Avanci AI'}</title>
        <meta name="avanci.ai" content="avanci.ai." />
      </Head>
      {components
        .filter((component) => component.show)
        .map(({ component: Component, props }, index) => (
          <Component key={index} {...props} />
        ))}
    </div>
  );
}
